// extracted by mini-css-extract-plugin
export default {"footer":"AppointmentCard_footer__dL64X","buttons":"AppointmentCard_buttons__uj73G","button":"AppointmentCard_button__ZxUrv"};